module.exports = __webpack_public_path__ + "img/disetujui_dibayarkan_sebagian.ab866858.svg";